import React, { useEffect, useState } from "react";
import {
  Avatar,
  Backdrop,
  Button,
  LogoLoader,
  Modal,
  TableAdv,
  showToast,
  SmartTooltip,
  StatusTags,
} from "../../../../components";
import { allBillsrowdata } from "../../../../assets/data/candidatesData";
import { dateFormator, getEmployeeId, mapTableRows } from "../../../../utils";
import { useSelector, useDispatch } from "react-redux";
import {
  getAccountPayablesStart,
  updateAccountPayablesStart,
} from "../../../../redux/slices/accountPayables/accountPayablesSlice";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import { usePagination } from "../../../../hooks";
import { Link, useNavigate } from "react-router-dom";
import { getVendorId } from "../../../../utils/getClientId";
import qb from "../../../../assets/qb.svg";
import { WORKFORCE_API_URL } from "../../../../redux/apiConfig";
import axios from "axios";
import QbAnimationLoading from "../../../../components/Module/Invoices/InvoiceModals/QbAnimationLoading";
import { formatCurrency } from "../../../../utils/stringUtils";
import dayjs from "dayjs";
import ApInvoiceDetails from "../Modals/ApInvoiceDetails";

const AllBills = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [qbLoading, setQbLoading] = useState(false);
  const [forceRerenderKey, setForceRerenderKey] = useState(0);
  const [sortConfig, setSortConfig] = useState({
    field: "uiid",
    direction: -1,
  });

  const { loading, error, accountPayables } = useSelector(
    (state) => state.accountPayables,
  );

  const { value } = useSelector((state) => state.totalCount);

  const totalCount = value?.accountpayables?.data;

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {
      // dispatch(getAccountPayablesStart({ page: newPage, limit: newLimit }));
    },
  );

  //const tablerowData = accountPayables;
  const tablerowData =
    accountPayables?.data?.map((a) => ({ ...a, id: a?.uiid })) || []; // Add null check with default empty array

  // Handle sort function
  const handleSort = (field) => {
    setSortConfig((prevSort) => ({
      field,
      // Toggle between 1 (ascending) and -1 (descending)
      direction: prevSort.field === field ? -prevSort.direction : -1,
    }));
  };

  const AllbillsColumns = [
    {
      key: "invoiceNum",
      label: "Invoice Number",
      render: (row) => (
        <div className="flex items-center gap-1">
          {/* <Link
            to={`/accounts-payable/edit/${row.uiid}`}
            state={{ code: row.uiid, edit: true }}
          > */}
          {/* <span className="text-linkblue">{row.invoiceNum}</span> */}
          <span
            className={`flex gap-2 items-center cursor-pointer ${
              row?.qbSync?.id
                ? "text-success"
                : row?.qbSync?.error
                  ? "text-danger"
                  : "text-linkblue"
            }`}
            onClick={() => setSelectedInvoice(row?.uiid)}
          >
            {row.invoiceNum}
          </span>
          <div className="flex items-center opacity-0 group-hover:opacity-100 transition-opacity duration-200">
            <SmartTooltip
              noicon
              description={
                row?.qbSync?.id ? "Synced with QB" : "Not synced with QB"
              }
              tooltipPosition="top"
              portal={true}
            >
              <div className="flex items-center justify-center w-[18px] h-[18px] mr-1">
                <img
                  src={row?.qbSync?.id ? "/QB.svg" : "/QB Icon-off.svg"}
                  alt="QuickBooks"
                  className="w-[20px] h-[20px]"
                />
              </div>
            </SmartTooltip>
          </div>
          {/* </Link> */}
        </div>
      ),
      //sortfun: () => handleSort("invoiceNum"),
    },
    {
      key: "employeeId",
      label: "Employees",
      width: "min-w-[250px]! max-w-[300px]!",
      render: (row) => {
        const employees = row?.employeeId || [];

        const employeeNames = employees
          .map((item) =>
            [
              item?.firstName,
              item?.lastName,
              getEmployeeId(item?.uiid, item?.employmentType),
            ]
              .filter(Boolean)
              .join(" "),
          )
          .join(", ");

        return (
          <SmartTooltip
            description={employeeNames}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
          >
            <div className="line-clamp-1">{employeeNames || "-"}</div>
          </SmartTooltip>
        );
      },
    },
    {
      key: "vendorId",
      label: "Vendor",
      width: "min-w-[250px]! max-w-[300px]!",
      render: (row) => {
        return (
          <SmartTooltip
            description={row.vendorId.businessName}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
          >
            <div className="line-clamp-1">
              {row.vendorId.businessName || "-"}
            </div>
          </SmartTooltip>
        );
      },
      sortfun: () => handleSort("vendorId.businessName"),
    },
    {
      key: "VendorID",
      label: "Vendor ID",
      render: (row) => {
        return <div>{getVendorId(row.vendorId.uiid)}</div>;
      },
      sortfun: () => handleSort("vendorId"),
    },
    {
      key: "invoiceDate",
      label: "Invoice Date",
      // render: (row) => dateFormator(row.invoiceDate, "month/date/year"),
      render: (row) => dayjs(row.invoiceDate).format("MM/DD/YYYY"),
    },
    {
      key: "dueDate",
      label: "Invoice Due Date",
      // render: (row) => dateFormator(row.dueDate, "month/date/year"),
      render: (row) => dayjs(row.dueDate).format("MM/DD/YYYY"),
    },
    {
      key: "billedAmount",
      label: "Bill Amount",
      render: (row) => formatCurrency(row.amounts.billed),
      sortfun: () => handleSort("billedAmount"),
    },
    {
      key: "paidAmount",
      label: "Paid Amount",
      render: (row) => formatCurrency(row.amounts.paid),
    },
    {
      key: "discountAmount",
      label: "Discount Amount",
      render: (row) => formatCurrency(row.amounts.discount),
    },
    {
      key: "dueAmount",
      label: "Due Amount",
      render: (row) => formatCurrency(row.amounts.due),
    },
    {
      key: "addedOn",
      label: "Created On",
      render: (row) => dayjs(row.addedOn).format("MM/DD/YYYY"),
    },
    {
      key: "modifiedOn",
      label: "Modified On",
      render: (row) => dateFormator(row.modifiedOn, "month-day-year"),
      // render: (row) => dayjs(row.modifiedOn).format("MM/DD/YYYY"),
    },
    {
      key: "Is Modified",
      label: "IsModified",
      render: (row) =>
        row.isModify ? <StatusTags tag={"Yes"} /> : <StatusTags tag={"No"} />,
    },
    {
      key: "Actions",
      label: "Actions",
      render: (row) => (
        <div className="flex items-center gap-2">
          <Button
            type="icon"
            icon="download"
            size="xs"
            variant="text"
            color="black"
            onClick={""}
          />
          <Button
            type="icon"
            icon="edit_square"
            size="xs"
            variant="text"
            color="black"
            onClick={() => navigate(`/accounts-payable/edit/${row.uiid}`)}
          />
          <Button
            type="icon"
            icon="delete"
            size="xs"
            variant="text"
            color="black"
            onClick={""}
          />
        </div>
      ),
    },
  ];

  const mappedRows = mapTableRows(tablerowData, AllbillsColumns);

  useEffect(() => {
    dispatch(
      getAccountPayablesStart({
        limit,
        page,
        filters: {
          //employmentType: { type: "NONE", value: 3 },
          //"isExit.status": { type: "NONE", value: false },
          // onBench: { type: "NONE", value: false },
        },
        // ret: "uiid invoiceNum employeeId vendorId invoiceDate dueDate amounts addedOn modifiedOn isModified",
        ref: "Employee Vendor",
        // incl: ["firstName lastName", "businessName"],
        incl: ["firstName lastName employementType", ""],
        sort: { [sortConfig.field]: sortConfig.direction },
      }),
    );
    dispatch(
      totalCountStart({
        collection: "accountpayables",
        coll: "AccountPayable",
        //filters: item.filters,
      }),
    );
  }, [dispatch, page, limit, sortConfig, forceRerenderKey]); // Empty array will cause it to run once when the component mounts

  const forceRerender = () => {
    console.log("F render:::::");
    setForceRerenderKey((prevKey) => prevKey + 1);
  };
  const handleQbSync = async (entity) => {
    if (selectedRowIds.length === 0) {
      showToast("Please select at least one invoice", "info", 5000);
      return;
    }
    let baseUrl = WORKFORCE_API_URL;
    try {
      setQbLoading(true);

      const selectedIds = selectedRowIds;
      const invoiceData = tablerowData?.filter((invoice) =>
        selectedIds.includes(invoice.uiid),
      );
      console.log("invoice data", invoiceData, tablerowData, selectedRowIds);
      let successCount = 0;
      let failedCount = 0;

      const buildVendorPayload = (data) => ({
        postActions: ["AddQBToVendor"],
        payload: {
          businessName: data?.businessName || "",
          uiid: data?.uiid || null,
          dbaName: data?.dbaName || "",
          email: data?.email || null,
          phone: data?.phone || null,
          website: data?.website || null,
          generalInfo: data?.generalInfo || null,
        },
      });

      const buildAPInvoicePayload = (invoice) => {
        const obj = invoice;
        return {
          ...(obj?.qbSync?.id && { qbSync: obj.qbSync }),
          uiid: obj?.uiid,
          invoiceNum: obj?.invoiceNum || undefined,
          invoiceBy: obj?.vendorId || undefined,
          employeeId: obj?.employeeId?.map((item) => item?.uiid) || undefined,
          approverId: obj?.approverId || undefined,
          vendorId: obj?.vendorId?.uiid || undefined,
          //as said incoive date is same a s billed dated
          invoiceDate: obj?.invoiceDate || undefined,
          billedDate: obj?.billedDate || undefined,
          dueDate: obj?.dueDate || undefined,
          netTerms: obj?.netTerms || undefined,
          amounts: obj?.amounts,
          // isModify: true,
          status: obj?.status || undefined,
          category: obj?.category || undefined,
          type: obj?.type || undefined,
          mailAddress: obj?.mailAddress || undefined,
          contacts: obj?.InvoiceContacts || undefined,
          emails: obj?.emails || undefined,
          invoiceDetails: obj?.invoiceDetails || [],
          discount:
            obj?.discounts?.map((item) => ({
              name: item?.name || undefined,
              type: item?.type || undefined,
              value: Number(item?.value) || undefined,
            })) || [],
          memo: obj?.memo || undefined,
          comments: obj?.comments || undefined,
        };
      };

      for (const invoice of invoiceData) {
        const vendorData = invoice.vendorId || {};
        const isVendorSynced = Boolean(vendorData?.qbSync?.id);

        if (!isVendorSynced) {
          try {
            const vendorPayload = buildVendorPayload(vendorData);
            await axios.post(`${baseUrl}/qb/vendors`, vendorPayload, {
              headers: { "Content-Type": "application/json" },
              withCredentials: true,
            });
          } catch (err) {
            console.error("Customer Sync Failed:", err.response || err);
            failedCount++;
            continue;
          }
        }

        const isAPInvoiceSynced = Boolean(invoice?.qbSync?.id);
        const invoicePayload = buildAPInvoicePayload(invoice);

        try {
          if (!isAPInvoiceSynced) {
            const res = await axios.post(
              `${baseUrl}/qb/${entity}`,
              {
                postActions: ["AddQBToAccPay"],
                payload: invoicePayload,
              },
              {
                withCredentials: true,
                headers: { "Content-Type": "application/json" },
              },
            );
            successCount++;
          } else {
            const res = await axios.post(
              `${baseUrl}/qb/${entity}`,
              {
                update: true,
                postActions: ["AddQBToAccPay"],
                payload: invoicePayload,
              },
              {
                withCredentials: true,
                headers: { "Content-Type": "application/json" },
              },
            );
            // dispatch(
            //   updateAccountPayablesStart({
            //     coll: "AccountPayable",
            //     uiid: invoicePayload?.uiid,
            //     qbId: invoicePayload?.qbSync?.id,
            //     syncFromQB: true,
            //     supressToast: true,
            //   })
            // );
            successCount++;
          }
        } catch (err) {
          console.error("Invoice Sync Error:", err);
          showToast(
            err?.response?.data?.error || "Bills Sync Error",
            "error",
            10000,
          );
          failedCount++;
        }
      }

      showToast(
        `QB Update Done: ${successCount} succeeded, ${failedCount} failed.`,
        failedCount > 0 ? "warning" : "success",
        6000,
      );
    } catch (err) {
      console.error("Unexpected QB Sync Error:", err);
      showToast("Unexpected Error Occurred", "error", 5000);
    } finally {
      setQbLoading(false);
      forceRerender();
    }
  };

  const handleQbDispatchSync = async () => {
    try {
      setQbLoading(true);

      if (selectedRowIds.length === 0) {
        showToast("Please select at least one invoice", "info", 5000);
        setQbLoading(false);
        return;
      }

      const invoiceData = tablerowData?.filter((invoice) =>
        selectedRowIds.includes(invoice.uiid),
      );

      let successCount = 0;
      let notSyncedCount = 0;

      for (const invoice of invoiceData) {
        if (!invoice?.qbSync?.id) {
          notSyncedCount++;
          continue;
        }

        try {
          await new Promise((resolve, reject) => {
            dispatch(
              updateAccountPayablesStart({
                coll: "AccountPayable",
                uiid: invoice.uiid,
                qbId: invoice.qbSync.id,
                syncFromQB: true,
                supressToast: true,
                onSuccess: () => resolve(),
                onFailure: () => reject(new Error("Sync failed")),
              }),
            );

            // Optional: Timeout fallback
            setTimeout(() => reject(new Error("Sync timeout")), 10000);
          });

          successCount++;
        } catch (err) {
          console.error(`Failed to sync invoice ${invoice.uiid}`, err);
        }
      }

      const message = `QB Sync Completed: ${successCount} succeeded, Update ${notSyncedCount} Invoice's to sync`;
      const status = successCount > 0 ? "success" : "warning";
      showToast(message, status, 4000);
    } catch (error) {
      console.error("Unexpected error during QB sync:", error);
      showToast("Unexpected error occurred during sync.", "error", 4000);
    } finally {
      setQbLoading(false);
      forceRerender();
    }
  };

  return (
    <div>
      <QbAnimationLoading
        isOpen={qbLoading}
        onClose={() => setQbLoading(false)}
      />
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
      <TableAdv
        tableId={"accountspayable_allbills"}
        onSelectionChange={(selected) => {
          setSelectedRowIds(selected);
        }}
        defaultSelectedRows={selectedRowIds}
        showCheckbox
        columns={AllbillsColumns}
        rows={mappedRows}
        // toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
        serverPagination={true}
        totalCount={totalCount}
        page={page}
        limit={limit}
        onPaginationChange={setPage}
        onLimitChange={handleLimitChange}
        toolbarRight={{
          search: true,
          filter: true,
          add: [
            {
              component: (
                <div className="flex items-center">
                  {/* <Button
                        type="icon"
                        icon={qb}
                        variant="text"
                        color="black"
                        onClick={() => setActiveModal("addQb")}
                      /> */}
                  {/* <button onClick={() => setActiveModal("addQb")} className="mx-1"> */}
                  <button
                    onClick={() => handleQbSync("bills")}
                    className="mx-1"
                  >
                    <Avatar src={qb} alt={"qb"} size="xs" outline />
                  </button>
                  {selectedRowIds?.length > 0 && (
                    <>
                      <Button
                        title="Sync to QB"
                        color="success"
                        onClick={() => handleQbDispatchSync()}
                      />
                    </>
                  )}
                </div>
              ),
            },
          ],
        }}
      />
      <Modal
        isOpen={selectedInvoice}
        title={"AP Invoice Details"}
        onClose={() => setSelectedInvoice(null)}
        showCloseButton={true}
        closeOnOutsideClick={true}
        width="max-w-full"
        zIndex={56}
      >
        <ApInvoiceDetails
          invoiceUiid={selectedInvoice}
          onBack={() => setSelectedInvoice(null)}
          removeButtonForPreview={false}
        />
      </Modal>
    </div>
  );
};

export default AllBills;
